export enum TransactionType {
  CREDIT = 0,
  DEBIT = 1
}

export enum StatementType {
  COURSE = 1,
  EVENT = 2,
  PILL = 3,
  ACCESS = 4,
  PRODUCT = 5
}

export enum StatementTypeCanceled {
  CANCELED = 1,
  VALID = 0
}
